module.exports = __webpack_public_path__ + "static/FraktionMono-Medium-6b258b4b53b043dbd62d750f4a6413ff.woff";